import { ChangeDetectionStrategy, Component, ElementRef, Output, ViewChild, EventEmitter, Input } from '@angular/core';

import { IAdditionalComponentsCatalogueCart } from '../../../../enclosure/models/product-accessories.model';
import { IBomModel } from '../../../../prisma-xs/models/bom.model';

declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-add-additional-components-from-catalogue-modal',
    templateUrl: './add-additional-components-from-catalogue-modal.component.html',
    styleUrl: './add-additional-components-from-catalogue-modal.component.scss',
    standalone: false
})
export class AddAdditionalComponentsFromCatalogueModalComponent {
  @ViewChild('addAdditionalComponentsFromCatalogModal') addAdditionalComponentsFromCatalogModalElement: ElementRef;

  @Input() productsInCart: IAdditionalComponentsCatalogueCart[];
  @Input() productsWithAdjustedQuantity: IBomModel[];

  @Output() cancel = new EventEmitter();
  @Output() confirm = new EventEmitter();

  openModal() {
    jQuery(this.addAdditionalComponentsFromCatalogModalElement.nativeElement).modal('show');
  }

  cancelAddingProducts() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.addAdditionalComponentsFromCatalogModalElement.nativeElement).modal('hide');
    this.cancel.emit();
  }

  confirmAddingProducts() {
    jQuery(this.addAdditionalComponentsFromCatalogModalElement.nativeElement).modal('hide');
    this.confirm.emit();
  }
}
